import { GeneratorBrowser } from '@sloyd/ui';
import { Explain, Gallery, Wrapper } from './Browser.style';

export type BrowserProps = {
  whiteThumbnails: boolean;
  generators: IGenerator[];
  isLoading: boolean;
  callbacks: {
    onAction: OnAction;
    onThumbChange: (value: string) => void;
  };
};

export function Browser(props: BrowserProps) {
  const { generators, isLoading, whiteThumbnails, callbacks } = props;

  return (
    <Wrapper className='Browser-wrapper' data-testid='Browser-wrapper'>
      <Explain ta='center'>Choose a generator:</Explain>
      <Gallery>
        <GeneratorBrowser
          generators={generators}
          isLoading={isLoading}
          onAction={callbacks.onAction}
          whiteThumbnails={whiteThumbnails}
          onThumbChange={callbacks.onThumbChange}
          spawn
        ></GeneratorBrowser>
      </Gallery>
      <Explain ta='center'>Or use a prompt:</Explain>
    </Wrapper>
  );
}

export default Browser;
